import AsideLayout from '../../components/layouts/aside-layout';
import AsideNavLink from '../../components/aside-nav-link';
import Head from 'next/head';
import LeadingLinks from '../../components/leading-links';
import MainLayout from '../../components/layouts/main-layout';
import HeroSustainability from '../../components/blocks/hero-sustainability';
import TickWhite from '../../public/img/ui/tick_white_1.png';
import LeafWhite from '../../public/img/ui/leaf_white_1.png';
import RecycleWhite from '../../public/img/ui/recycle_white_1.png';
import GraphBlue from '../../public/img/ui/graph_blue_1.png';
import LeafBlue from '../../public/img/ui/leaf_blue_1.png';
import PageBlue from '../../public/img/ui/page_blue_1.png';
import TickSeachange from '../../public/img/ui/tick_seachange_2.png';
import TrustBlue from '../../public/img/ui/trust_blue_1.png';
import Image from 'next/image';

function Sustainability(props) {
    return (
        <MainLayout>
            <Head>
                <title>Sustainability | Solvar</title>
                <meta name="description" content="Solvar sustainability and climate action projects."></meta>
            </Head>
            <HeroSustainability />
            <AsideLayout
                prev={
                    <LeadingLinks href="/about-us/philanthropy" prev>Philanthropy</LeadingLinks>
                }
                aside={
                    <>
                        <h6 className="text-h3 text-bb pb-20">About Us</h6>
                        <AsideNavLink href="/about-us/company-overview">Company Overview</AsideNavLink>
                        <AsideNavLink href="/about-us/history">History</AsideNavLink>
                        <AsideNavLink href="/about-us/board-of-directors">Board of Directors</AsideNavLink>
                        <AsideNavLink href="/about-us/management-team">Management Team</AsideNavLink>
                        <AsideNavLink href="/about-us/corporate-governance">Corporate Governance</AsideNavLink>
                        <AsideNavLink href="/about-us/philanthropy">Philanthropy</AsideNavLink>
                        <AsideNavLink href="/about-us/sustainability" active={true}>Sustainability</AsideNavLink>
                        <h6 className="text-h3 text-bb pb-20 pt-40">Investors</h6>
                        <AsideNavLink href="/investors/shareholder-information">Shareholder Information</AsideNavLink>
                        <AsideNavLink href="/investors/company-announcements">Company Announcements</AsideNavLink>
                        <AsideNavLink href="/investors/annual-reports">Annual Reports</AsideNavLink>
                        <h6 className="text-h3 text-bb pb-20 pt-40">Contact</h6>
                        <AsideNavLink href="/contact/contact-us">Contact Us</AsideNavLink>
                    </>
                }
            >
                <ul className="grid grid-cols-1 sm:grid-cols-3 gap-30 mb-40">
                    <li className="bg-bb p-20 text-center">
                        <Image
                            src={ LeafWhite }
                            alt="A Leaf Icon"
                            height={ 48 }
                            className="block mx-auto mb-20"
                        />
                        <h4 className="text-white">Measure</h4>
                        <p className="text-white text-copy-sm">We track and measure our carbon emmissions across the business</p>
                    </li>
                    <li className="bg-bb p-20 text-center">
                        <Image
                            src={ RecycleWhite }
                            alt="A Recycle Icon"
                            height={ 48 }
                            className="block mx-auto mb-20"
                        />
                        <h4 className="text-white">Reduce</h4>
                        <p className="text-white text-copy-sm">We minimise waste and energy use through smart practices in our offices</p>
                    </li>
                    <li className="bg-bb p-20 text-center">
                        <Image
                            src={ TickWhite }
                            alt="A Tick Icon"
                            height={ 48 }
                            className="block mx-auto mb-20"
                        />
                        <h4 className="text-white">Report</h4>
                        <p className="text-white text-copy-sm">Planning is underway to prepare a full Climate Report in FY27.</p>
                    </li>
                </ul>
                <div className="sm:bg-grey py-40 mb-40">
                    <h2 className="text-center">Our Sustainability Strategy</h2>
                    <ul className="grid grid-cols-1 sm:grid-cols-3 gap-30 mb-20 sm:mb-0">
                        <li className="bg-grey p-20 text-center">
                            <Image
                                src={ GraphBlue }
                                alt="A Graph Icon"
                                height={ 48 }
                                className="block mx-auto mb-20"
                            />
                            <h4 className="">Policies & Governence</h4>
                            <p className="text-copy-sm">Embedding sustainability in our operations and supply chain</p>
                        </li>
                        <li className="bg-grey p-20 text-center">
                            <Image
                                src={ PageBlue }
                                alt="A Page Icon"
                                height={ 48 }
                                className="block mx-auto mb-20"
                            />
                            <h4 className="">Risk Management</h4>
                            <p className="text-copy-sm">Tracking climate risks and opportunities in our Group Risk Register</p>
                        </li>
                        <li className="bg-grey p-20 text-center">
                            <Image
                                src={ LeafBlue }
                                alt="A Leaf Icon"
                                height={ 48 }
                                className="block mx-auto mb-20"
                            />

                            <h4 className="">Transparency</h4>
                            <p className="text-copy-sm">Reporting annually, with a sustainability report from FY27</p>
                        </li>
                    </ul>
                </div>
                <h2 className="text-center mb-20">The Actions We Take</h2>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-30 mb-40">
                    <li className="flex items-center gap-20 p-20 shadow-md">
                        <Image
                            src={ TickSeachange }
                            alt="A Tick Icon"
                            height={ 32 }
                            className="block"
                        />
                        <p className="text-copy-sm">Recycling of office waste and electronics</p>
                    </li>
                    <li className="flex items-center gap-20 p-20 shadow-md">
                        <Image
                            src={ TickSeachange }
                            alt="A Tick Icon"
                            height={ 32 }
                            className="block"
                        />
                        <p className="text-copy-sm">Smart printing & lighting systems in our offices</p>
                    </li>
                    <li className="flex items-center gap-20 p-20 shadow-md">
                        <Image
                            src={ TickSeachange }
                            alt="A Tick Icon"
                            height={ 32 }
                            className="block"
                        />
                        <p className="text-copy-sm">Bin tracker system in Brisbane office</p>
                    </li>
                    <li className="flex items-center gap-20 p-20 shadow-md">
                        <Image
                            src={ TickSeachange }
                            alt="A Tick Icon"
                            height={ 32 }
                            className="block"
                        />
                        <p className="text-copy-sm">Energy-efficient cloud services providers</p>
                    </li>
                    <li className="flex items-center gap-20 p-20 shadow-md">
                        <Image
                            src={ TickSeachange }
                            alt="A Tick Icon"
                            height={ 32 }
                            className="block"
                        />
                        <p className="text-copy-sm">Monitor sustainability actions of suppliers</p>
                    </li>
                </ul>
                <div className="bg-grey flex gap-20 py-60 px-40 xl:px-[10%] items-top justify-center">
                    <Image
                        src={ TrustBlue }
                        alt="A Trust Icon"
                        className="h-[47px]"
                    />
                    <p className="text-center">ISO 14001 is the international standard for environmental management systems, whilst ISO 50001 focuses on energy management. Given the nature and scale of our operations, Solvar has elected not to certify to ISO 14001 or 50001, nor do we require our suppliers to be certified to these standards. However, our Supplier policy seeks where possible to engage vendors who can demonstrate that their activities align with our commitment to take climate action.</p>
                </div>
                <blockquote className="bg-hg px-40 py-60 text-center mb-40">
                    <p className="pb-40">
                        <i>
                            "Sustainability is not a destination - it's an ongoing journey. Solvar is committed to evolving our practices, engaging our people, and reporting transparently so we can continue to grow responsibly, together."
                        </i>
                    </p>
                    <cite className="text-copy-sm">-Solvar</cite>
                </blockquote>
            </AsideLayout>
        </MainLayout>
    );
}

export default Sustainability;